function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledDescriptiveLinkBlock } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/descriptive-link-block/descriptive-link-block.scss";
const DescriptiveLinkBlock = ({ Icon, link, title, description, TitleIcon, onClick, disabled })=>{
    const ElementTag = disabled ? "div" : "a";
    const linkProps = disabled ? {} : {
        href: link,
        onClick
    };
    return /*#__PURE__*/ _jsxs(StyledDescriptiveLinkBlock, _object_spread_props(_object_spread({
        as: ElementTag,
        className: "descriptive-link-block"
    }, linkProps), {
        children: [
            /*#__PURE__*/ _jsx(Icon, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "details",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "title",
                        children: [
                            title,
                            TitleIcon && /*#__PURE__*/ _jsx(TitleIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    }));
};
export default DescriptiveLinkBlock;
